import React, { useState } from "react";
import { colors } from "../../styles/colors";
import Heading from "../Header/Heading";
import {
  AccordionWrapper,
  AccordionTitle,
  AccordionAction,
  AccordionContent,
  AccordionDescription,
} from "./Accordion.style";

const Accordion = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div data-aos="fade-up" style={{ width: "100%" }}>
      <AccordionWrapper $isActive={isActive}>
        <AccordionTitle onClick={() => setIsActive(!isActive)}>
          <Heading color={colors.lightdark} as="h2" className="mt-0 mb-0">
            {title}
          </Heading>
          <AccordionAction $isActive={isActive}>
            {isActive ? "−" : "+"}
          </AccordionAction>
        </AccordionTitle>

        <AccordionContent $isActive={isActive}>
          <AccordionDescription>{content}</AccordionDescription>
        </AccordionContent>
      </AccordionWrapper>
    </div>
  );
};

export default Accordion;
